import React from "react";
import Card from "../../../components/page/Card";
import AcordeaoWrapper from "../../../components/acordeao/AcordeaoWrapper";
import AcordeaoItem from "../../../components/acordeao/AcordeaoItem";

function DuvidasFrequentes() {
  return (
    <div className="row justify-content-center mt-5">
      <div className="col-md-12 col-xl-10">
        <Card>
          <div className="row m-4 mt-3">
            <div className="col-md-12">
              <span style={{ fontWeight: 600 }} className="font-size-24">
                Dúvidas frequentes
              </span>
            </div>
          </div>
          <div className="row m-4 mt-5">
            <AcordeaoWrapper>
              <AcordeaoItem
                id="1"
                titulo="O que é um Certificado Digital?"
                ativo
              >
                Certificado Digital é uma assinatura eletrônica que utiliza
                chaves de segurança para confirmar a identidade da empresa.
                <br />
                <br />
                O Certificado Digital pode ser tanto de pessoa física como
                jurídica. Geralmente o e-CPF é utilizado na abertura da empresa,
                já o e-CNPJ é renovado a cada 12 meses.
                <br />
                <br />
                Para podermos atender sua empresa, todo cliente Orangiuz precisa
                ter o Certificado Digital e-CNPJ, assim podemos garantir que
                todas as funcionalidades da plataforma estejam ativas (como
                emissão de Notas Fiscais) e também as entregas das obrigações
                fiscais de sua empresa em dia. Essa obrigatoriedade do
                Certificado Digital consta no nosso contrato de prestação de
                serviços e seu certificado será mantido em nossa plataforma de
                maneira sigilosa e segura.
                <br />
                <br />
                Importante: Quem deve fazer o Certificado Digital é sempre o
                sócio responsável pela empresa na Receita Federal.
              </AcordeaoItem>
              <AcordeaoItem
                id="2"
                titulo="Porque preciso de um Certificado Digital para a minha empresa?"
              >
                Todo cliente Orangiuz precisa adquirir o certificado digital
                e-CNPJ A1 para computador.
                <br />
                <br />
                É através do Certificado que garantimos a entrega das obrigações
                contábeis da sua empresa dentro dos prazos, evitando multas e
                penalidades.
                <br />
                <br />
                Além disso, o certificado garante que a sua contabilidade será
                totalmente digital, assim você não precisará fazer visitas
                constantes aos órgãos públicos.
              </AcordeaoItem>
              <AcordeaoItem id="3" titulo="Porque perguntamos se você tem CNH?">
                Para concluir a emissão do seu Certificado Digital e-CNPJ você
                precisará realizar uma entrevista com a nossa certificadora
                parceira, a Soluti.
                <br />
                <br />
                Esta entrevista é necessária para validar a veracidade das suas
                informações pessoais e trazer maior segurança para o processo.
                <br />
                <br />
                Caso você possua uma CNH, é possível realizar a entrevista
                através de vídeo conferência, tornando a emissão muito mais
                prática.
                <br />
                <br />
                Para que a CNH possa ser usada para realizar a entrevista
                através de vídeo conferência, ela deve seguir algumas regras:
                <br />
                <br />
                <ul style={{ listStyleType: "disc" }}>
                  <li>Pertencer ao sócio responsável pela empresa</li>
                  <li>Estar dentro da validade e sem qualquer suspensão</li>
                  <li>
                    Caso você não tenha uma CNH, ou tenha mas esteja fora das
                    regras, você poderá realizar a entrevista com a
                    certificadora presencialmente.
                  </li>
                </ul>
                Lembre-se de responder com atenção à pergunta sobre CNH.
                Qualquer informação incorreta pode atrasar o seu processo de
                emissão.
              </AcordeaoItem>
              <AcordeaoItem
                id="4"
                titulo="Estou sem faturar, mesmo assim preciso do Certificado Digital e-CNPJ?"
              >
                Mesmo sem movimentação na empresa é necessário ter o certificado
                digital e-CNPJ para podermos entregar as obrigações acessórias
                mensais e anuais. Mesmo sem faturar você continua com sua
                empresa aberta e deve manter ela com um contador responsável, no
                caso a Orangiuz.
                <br />
                <br />
                Você continua pagando nossa mensalidade e nós continuamos a
                enviar todas as obrigações necessárias de sua empresa. Essa
                opção é válida se houver a possibilidade de utilizar a sua
                empresa no futuro, pois assim ela estará com as obrigações em
                dia e você poderá emitir suas notas normalmente.
                <br />
                <br />
                Com a empresa aberta, não é possível simplesmente deixar de
                realizar as obrigações contábeis com o Governo, pois dessa forma
                poderá gerar pendências com o Governo e se desejar utilizar a
                empresa novamente será necessário realizar as devidas
                regularizações.
              </AcordeaoItem>
              <AcordeaoItem
                id="5"
                titulo="Como funciona o processo de validação por videoconferência?"
              >
                A videoconferência é feita em um sistema próprio da
                certificadora. Ela substitui o atendimento presencial,
                garantindo mais conforto para você. A entrevista de validação é
                um passo essencial para a emissão do seu certificado digital.
                <br />
                <br />
                Durante a videoconferência é feita a captura da foto sua e a
                confirmação de alguns dados pessoais. Isso serve para garantir a
                segurança no processo de solicitação.
                <br />
                <br />
                Por isso, nessa entrevista por videoconferência, você precisa
                estar em um ambiente tranquilo e com a possibilidade de tirar
                uma foto com um fundo neutro (branco, de preferência, em que não
                haja nada atrás de você). Essa foto é importante, pois servirá
                para garantir a segurança do seu cadastro.
                <br />
                <br />
                É necessário que você tenha CNH emitida ou renovada após 2017.
                <br />
                <br />
                Após essa entrevista, você já vai poder dar continuidade à
                emissão do seu certificado.
                <br />
                <br />
                Importante: em nome da segurança dos dados, não é possível
                gravar o áudio ou o vídeo da entrevista.
              </AcordeaoItem>
              <AcordeaoItem
                id="6"
                titulo="Como renovar o Certificado Digital E-CNPJ?"
              >
                O certificado digital e-CNPJ A1 é válido por 1 ano e sua
                vigência tem início a partir da data que efetuar a validação com
                a Soluti, seja presencial ou online.
                <br />
                <br />A renovação do certificado digital e-CNPJ é obrigatória
                para atendermos sua empresa e tem como objetivo garantir que
                todas as obrigações contábeis, incluindo o e-Social, possam ser
                entregues dentro dos prazos evitando multas e penalidades.
              </AcordeaoItem>
            </AcordeaoWrapper>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default DuvidasFrequentes;
